<template>
	<div>
		<v-card>
			<v-card-title class="headline">Factura de venta</v-card-title>

			<v-card-text>

				<v-menu
					ref="menuFechaFactura"
					v-model="diálogoFechaDeEmisión"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="datos.fechaDeEmisión"
							label="Fecha de emisión de la factura (Opcional)"
							hint="* Si deja este campo en blanco se asumirá la fecha actual"
							persistent-hint
							readonly
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="datos.fechaDeEmisión"
						@input="diálogoFechaDeEmisión = false"
						:first-day-of-week="1"
						show-adjacent-months
						:max="hoy"
						scrollable
					>
					</v-date-picker>
				</v-menu>

				<v-autocomplete
					label="Seleccione un producto para agregar y pulse en el botón «+»:"
					v-model="productoSeleccionado"
					:items="fuenteProductos.listado"
					item-value="identificador"
					item-text="descripción"
					append-outer-icon="mdi-plus"
					menu-props="auto"
					@click:append-outer="agregarProducto"
					class="mt-8"
				></v-autocomplete>

				<br>
				<factura-constructor-tabla ref="factura"></factura-constructor-tabla>

			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn
					color="grey darken-1"
					text
					:disabled="fuente.guardando"
					@click="cancelar"
				>
					Cancelar
				</v-btn>

				<v-btn
					color="green darken-1"
					text
					:loading="fuente.guardando"
					@click="guardar"
				>
					Guardar
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>


<script>
import { facturasDeVenta, productos, definicionesDeImpuestos } from '@/../../cliente_comun/fuentes'
import facturaConstructorTabla from '@/../../cliente_comun/factura_constructor_tabla.vue'

export default {
	name: 'factura-de-venta',
  data: () => ({
		fuente: facturasDeVenta,
		fuenteProductos: productos,
		definicionesDeImpuestos: definicionesDeImpuestos,
		diálogoFechaDeEmisión: false,
		productoSeleccionado: null,
		datos: {
			fechaDeEmisión: null
		},
		hoy: new Date().toISOString().substr(0, 10),
	}),
	components: {
		facturaConstructorTabla
	},
	mounted: function() {
		this.fuenteProductos.inicializar()
		this.definicionesDeImpuestos.inicializar()
	},
	methods: {
		guardar: function() {
			let confirma = window.confirm('¿Proceder a generar la factura?')
			if (confirma) {
				let datos = Object.assign({fechaDeEmisión: this.datos.fechaDeEmisión}, this.$refs.factura.obtenerDatos())
				this.fuente.guardar(datos).then( rta => {
					this.limpiar()
					this.$emit('guardar', true)
				}).catch(() => { })
			}
		},
		agregarProducto: function() {
			if (this.productoSeleccionado) {
				let p = this.fuenteProductos.listado.find( el => el.identificador === this.productoSeleccionado)
				this.$refs.factura.agregarProducto(p)
			}
		},
		cancelar: function() {
			this.limpiar()
			this.$emit('cancelar', true)
		},
		limpiar: function() {
			this.$refs.factura.limpiar()
			this.diálogoFechaDeEmisión = false
			this.productoSeleccionado = null
			this.datos.fechaDeEmisión = null
		}
	}
}
</script>